import React from 'react'

type StatusVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral'

interface StatusPillProps { variant?: StatusVariant; children: React.ReactNode; style?: React.CSSProperties }

const STATUS_PILL_STYLES: Record<StatusVariant, { bg: string; color: string }> = {
  success: { bg: 'rgba(34,197,94,0.12)',  color: 'var(--success)' },
  warning: { bg: 'rgba(234,179,8,0.12)',  color: 'var(--warning)' },
  error:   { bg: 'rgba(239,68,68,0.12)',  color: 'var(--error)'   },
  info:    { bg: 'rgba(124,58,237,0.10)', color: 'var(--accent-primary)' },
  neutral: { bg: 'var(--bg-elevated)',    color: 'var(--text-muted)' },
}

export const StatusPill: React.FC<StatusPillProps> = ({ variant = 'neutral', children, style }) => {
  const s = STATUS_PILL_STYLES[variant]
  return (<span style={{ display: 'inline-flex', alignItems: 'center', padding: '0.15rem 0.55rem', borderRadius: '20px', fontSize: '0.72rem', fontWeight: 600, background: s.bg, color: s.color, whiteSpace: 'nowrap', ...style }}>{children}</span>)
}
